export const isRouteAuthenticationRequired = (toRoute) => ({
    required: toRoute.matched.some(route => route.meta.requiresAuth),
    allowed: toRoute.meta.allowedRoles
  });